import React from 'react'
import type { BetSlipItem, FobDetails } from '@mobi/betslip/types'
import { toTitleCase } from '@mobi/utils/string'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { spacing } from '@mobi/component-library/Foundations'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'
import { MultiBetLegPriceStyled } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/BetSelectionInfo.styles'

export const FobHeader: React.FC<{
  selectionDetails: FobDetails
  betLegType: BetSlipItem['multiLegBetType']
  legOdds?: number | null
}> = ({ selectionDetails, betLegType, legOdds }) => {
  const {
    sportIconCode,
    tournamentName,
    competitionName,
    eventName,
    marketName,
    propositionName,
    handicapName,
  } = selectionDetails

  return (
    <Flex flexDirection='column' gap={spacing.smx1}>
      <SecondaryInfo
        marketInfo={
          <>
            <Icon size='1.6rem' type={sportIconCode} />

            {tournamentName ? (
              <span>
                {competitionName} {tournamentName}
              </span>
            ) : (
              <span>{competitionName}</span>
            )}

            {eventName && eventName !== marketName && eventName !== competitionName && (
              <span>{eventName}</span>
            )}
          </>
        }
      />

      <SelectionInfo
        text={`${toTitleCase(propositionName)} ${handicapName ? handicapName : ''}`}
        subText={betLegType === 'W' ? 'Win' : 'Place'}
        rightSlot={
          betLegType ? <MultiBetLegPriceStyled>{legOdds}</MultiBetLegPriceStyled> : undefined
        }
      />
    </Flex>
  )
}
